<ng-container *ngIf="vo$ | async; let vo">
	<app-page *ngIf="!vo.isLoading && !vo.embedded">
		<app-page-header>
			<app-breadcrumb [paths]="paths"></app-breadcrumb>
		</app-page-header>

		<app-page-actions>
			<button
				id="{{ cmpId }}-new-btn"
				*ngIf="vo.canCreate"
				matTooltip="new"
				i18n-matTooltip="@@general.action.new"
				matTooltipPosition="left"
				class="exposition-list-new"
				mat-icon-button
				color="primary"
				(click)="createNewExposition()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</app-page-actions>

		<app-page-content>
			<ng-container [ngTemplateOutlet]="grid"></ng-container>
		</app-page-content>
	</app-page>

	<ng-container
		*ngIf="!vo.isLoading && vo.embedded"
		[ngTemplateOutlet]="grid"></ng-container>

	<ng-template #grid>
		<div
			*ngIf="vo.canCreate && vo.embedded"
			class="app-exposition-create-embedded">
			<button
				id="{{ cmpId }}-new-btn"
				matTooltip="new"
				i18n-matTooltip="@@general.action.new"
				matTooltipPosition="left"
				class="exposition-list-new"
				mat-icon-button
				color="primary"
				(click)="createNewExpositionFromEmbeddedView()">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
		</div>
		<app-panel
			headerHeight="3rem"
			isAlwaysOpen="true"
			hasSearchableGrid="true"
			hasRefresh="true"
			maxActionsCount="6"
			[actionsAvailable]="toggleActions"
			[itemsCount]="vo.list.elements.size"
			[actions]="columnsActions"
			(refresh)="refresh()"
			(search)="search($event)">
			<div panel-title class="app-panel__title">
				<mat-icon [svgIcon]="DcIcons.ExposeDatablock"></mat-icon>
				<span i18n="@@expositions.list">Expositions</span>
			</div>
			<span panel-info>
				<div *ngIf="selectionCount">
					<span>{{ selectionCount }} &#32;</span>
					<span i18n="@@expositions.columns.config.selectedElements">
						selected-elements
					</span>
				</div>
			</span>
			<dx-data-grid
				keyExpr="id"
				[attr.data-embedded]="vo.embedded"
				[elementAttr]="{
					id: 'expositions-list',
					class: 'app-exposition-list'
				}"
				[dataSource]="vo.list.elements | toArray"
				[hoverStateEnabled]="true"
				[showColumnHeaders]="true"
				[allowColumnResizing]="true"
				[wordWrapEnabled]="false"
				[columnAutoWidth]="false"
				[showRowLines]="false"
				[showColumnLines]="false"
				[rowAlternationEnabled]="false"
				[showBorders]="false"
				[width]="'100%'"
				[noDataText]="''"
				(onCellClick)="cellClick($event)"
				(onCellHoverChanged)="onCellHover($event)"
				(onSelectionChanged)="onSelectionChange($event)"
				(onContentReady)="onGridContentReady()">
				<dxo-selection
					mode="multiple"
					[showCheckBoxesMode]="
						vo.embedded ? 'none' : 'always'
					"></dxo-selection>

				<dxo-load-panel
					shadingColor="rgba(0,0,0,0)"
					[indicatorSrc]="DcLoaders.LoaderInfinite"
					[height]="100"
					[width]="100"
					[enabled]="vo.isFirstLoad"
					[showIndicator]="true"
					[showPane]="true"
					[shading]="true"></dxo-load-panel>

				<!-- Fixable in position columns	-->
				<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

				<ng-container *ngFor="let col of vo.list.availableColumns | toArray">
					<dxi-column
						cssClass="dxList--clickable"
						*ngIf="col.field === 'label'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[visible]="col.visible"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[format]="col.format"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'tags'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[visible]="col.visible"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[format]="col.format"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[calculateFilterExpression]="calculateTagsHeaderFilterExpression"
						[filterOperations]="[DxOperations.Contains, DxOperations.In]"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"
						cellTemplate="expositionTagsTemplate">
						<dxo-header-filter
							[dataSource]="tagsHeaderFilter"></dxo-header-filter>
					</dxi-column>
					<dxi-column
						*ngIf="col.field === 'apiStatus'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[format]="col.format"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 140"
						[filterOperations]="[DxOperations.In]"
						cellTemplate="expositionStatusTemplate">
						<dxo-header-filter
							[dataSource]="statusHeaderFilter"></dxo-header-filter>
					</dxi-column>
					<dxi-column
						*ngIf="col.field === 'columnsCount'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="false"
						[allowFiltering]="false"
						[allowSorting]="false"
						[format]="col.format"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[dataType]="col.type"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width"
						cellTemplate="configurationTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'datablockSource'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width"
						cellTemplate="datablockSourceTemplate"></dxi-column>
					<dxi-column
						cssClass="dxList--h6"
						*ngIf="col.field === 'accessPointLabel'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 200"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'duration'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 80"
						cellTemplate="durationTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'dataEntries'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 80"
						cellTemplate="dataLinesTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'lastElemModification'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[dataType]="col.type"
						[format]="col.format"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width"
						cellTemplate="lastElemModificationTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'lastElemModificationBy'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="false"
						[alignment]="'left'"
						[dataType]="col.type"
						[format]="col.format"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[filterOperations]="[
							DxOperations.Contains,
							DxOperations.NotContains,
							DxOperations.StartsWith,
							DxOperations.In
						]"
						[calculateFilterExpression]="
							calculateActionByHeaderFilterExpression
						"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 40"
						cellTemplate="lastElemModificationByTemplate">
						<dxo-header-filter
							[dataSource]="modifiedByHeaderFilter"></dxo-header-filter>
					</dxi-column>
					<dxi-column
						*ngIf="col.field === 'lastExpositionAction'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="true"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[format]="col.format"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width"
						cellTemplate="lastExpositionActionTemplate"></dxi-column>
					<dxi-column
						*ngIf="col.field === 'lastExpositionActionBy'"
						[dataField]="col.field"
						[caption]="col.alias"
						[groupIndex]="col.groupIdx"
						[fixed]="false"
						[allowResizing]="true"
						[allowHiding]="true"
						[allowGrouping]="true"
						[allowSearch]="col.isSearchable"
						[allowFiltering]="col.isFilterable"
						[allowSorting]="false"
						[alignment]="'left'"
						[visibleIndex]="col.visibleIndex"
						[allowHeaderFiltering]="col.hasHeaderFilter"
						[dataType]="col.type"
						[format]="col.format"
						[visible]="col.visible"
						[filterValue]="col.filterValue"
						[filterValues]="col.filterValues"
						[sortIndex]="col.sortIndex"
						[sortOrder]="col.sortOrder"
						[width]="col.width ?? 40"
						[filterOperations]="[
							DxOperations.Contains,
							DxOperations.NotContains,
							DxOperations.StartsWith,
							DxOperations.In
						]"
						[calculateFilterExpression]="
							calculateActionByHeaderFilterExpression
						"
						cellTemplate="lastExpositionActionByTemplate">
						<dxo-header-filter
							[dataSource]="actionByHeaderFilter"></dxo-header-filter>
					</dxi-column>
				</ng-container>

				<dxi-column
					[fixed]="false"
					[allowResizing]="false"
					[allowHiding]="false"
					[allowGrouping]="false"
					[allowSearch]="false"
					[allowSorting]="false"
					[alignment]="'left'"
					[visibleIndex]="vo.list.availableColumns.size + 1"
					[width]="70"
					[showInColumnChooser]="false"
					cellTemplate="actionsTemplate"></dxi-column>

				<div class="" *dxTemplate="let cell of 'dataLinesTemplate'">
					<app-overlay-badge
						matTooltip="total lines published"
						i18n-matTooltip="@@expositions.history.list.lines.tooltip"
						*ngIf="cell.data['apiStatus'] !== PublicationStatus.Unpublished"
						[icon]="ComponentIcons.Data"
						[value]="cell.data['dataEntries']"
						[active]="false"></app-overlay-badge>
				</div>

				<div
					class="configuration-column-template"
					*dxTemplate="let cell of 'configurationTemplate'">
					<ng-container
						*ngIf="cell.data['apiStatus'] !== PublicationStatus.Unpublished">
						<app-overlay-badge
							matTooltip="columns"
							i18n-matTooltip="@@exposition.access.list.column.columns"
							[active]="false"
							[icon]="ComponentIcons.Column"
							[value]="cell.data['columnsCount']"></app-overlay-badge>
						<app-overlay-badge
							matTooltip="access"
							i18n-matTooltip="@@expositions.history.list.access"
							[active]="false"
							[icon]="ComponentIcons.Access"
							[value]="cell.data['accessCount']"></app-overlay-badge>
						<app-overlay-badge
							id="overlaybadge-endpointMetadata"
							matTooltip="endpoint metadata"
							i18n-matTooltip="@@exposition.metadata.public"
							[active]="true"
							[icon]="ComponentIcons.PublicEndpointMetadata"
							[isOpen]="vo.openedOverlays.endpointMetadata === cell.data['id']"
							(click)="openEndpointMetadataPopover($event, cell.data['id'])">
							<app-popover
								id="popover-endpointMetadata"
								overlayContent
								label="endpoint"
								i18n-label="@@exposition.metadata.public"
								[icon]="{ iconName: ComponentIcons.PublicEndpointMetadata }"
								(adbPopoverClose)="closeOverlay()">
								<span *ngIf="vo.isLoadingMetadata" class="loading-spinner">
									<mat-spinner></mat-spinner>
								</span>
								<app-exposition-endpoint-metadata-config
									*ngIf="!vo.isLoadingMetadata"
									[expositionMetadata]="vo.endpointMetadata"
									[isInViewMode]="
										true
									"></app-exposition-endpoint-metadata-config>
							</app-popover>
						</app-overlay-badge>
					</ng-container>
				</div>

				<div class="" *dxTemplate="let cell of 'expositionStatusTemplate'">
					<app-exposition-publication-status
						[status]="
							cell.data['actionInProgress'] || cell.data['isApiStatusRunning']
								? PublicationStatus.Running
								: cell.data['apiStatus']
						"></app-exposition-publication-status>
				</div>

				<div
					*dxTemplate="let cell of 'expositionTagsTemplate'"
					class="label-column-template">
					<app-tag-configurator
						*ngIf="cell.data['tags'].length !== 0"
						displayMode="tags"
						configMode="View"
						[configuredTags]="cell.data['tags']"></app-tag-configurator>
				</div>

				<div
					class="datablock-source-column-template"
					matTooltip="open exposition in new tab"
					i18n-matTooltip="@@exposition.list.sourceTooltip"
					matTooltipPosition="after"
					*dxTemplate="let cell of 'datablockSourceTemplate'">
					<a
						id="{{ cmpId }}-{{ cell.rowIndex }}-datablockSource-nav-link"
						appNavigate
						[navigateTo]="cell.data['sourceUrl']"
						[matTooltip]="cell.data['datablockSource']"
						[matTooltipDisabled]="cell.data['datablockSource'].length < 24"
						matTooltipPosition="left">
						{{ cell.data['datablockSource'] }}
					</a>
					<a
						appNavigate
						[navigateTo]="cell.data['sourceUrl']"
						[hidden]="cell.rowIndex !== currentlyHovered">
						<mat-icon [svgIcon]="DcIcons.OpenInNewTab"></mat-icon>
					</a>
				</div>

				<div
					class="last-elem-modification-column-template"
					*dxTemplate="let cell of 'lastElemModificationTemplate'">
					<span>
						{{
							cell.data['lastElemModification'] | date: 'yyyy-MM-dd HH:mm:ss'
						}}
					</span>
				</div>

				<div
					class="last-elem-modification-column-template"
					*dxTemplate="let cell of 'lastElemModificationByTemplate'">
					<app-avatar
						avatarSize="small"
						withTooltip="true"
						[avatar]="cell.data['lastElemModificationBy']"></app-avatar>
				</div>

				<div
					class="last-exposition-action-column-template"
					*dxTemplate="let cell of 'lastExpositionActionTemplate'">
					<span
						*ngIf="cell.data['apiStatus'] !== PublicationStatus.Unpublished">
						{{
							cell.data['lastExpositionAction'] | date: 'dd-MM-yyyy HH:mm:ss'
						}}
					</span>
				</div>

				<div
					class="last-exposition-action-column-template"
					*dxTemplate="let cell of 'lastExpositionActionByTemplate'">
					<app-avatar
						*ngIf="
							cell.data['apiStatus'] !== PublicationStatus.Unpublished &&
							cell.data['lastExpositionActionBy'] !== null
						"
						avatarSize="small"
						withTooltip="true"
						[avatar]="cell.data['lastExpositionActionBy']"></app-avatar>
				</div>

				<div *dxTemplate="let cell of 'durationTemplate'">
					<span
						*ngIf="cell.data['apiStatus'] !== PublicationStatus.Unpublished">
						{{ cell.data['duration'] }} s
					</span>
				</div>

				<div
					*dxTemplate="let cell of 'actionsTemplate'"
					class="actions-column-template">
					<div [hidden]="cell.rowIndex !== currentlyHovered">
						<button
							*ngIf="cell.data['apiStatus'] !== PublicationStatus.Unpublished"
							mat-icon-button
							class="actions-column-template__menu-btn"
							matTooltip="update-expose"
							i18n-matTooltip="@@expositions.list.data"
							matTooltipPosition="left"
							(click)="updateExpositionData(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.UpdateExpositionData"></mat-icon>
						</button>
						<button
							*ngIf="cell.data['apiStatus'] === PublicationStatus.Unpublished"
							mat-icon-button
							class="actions-column-template__menu-btn"
							matTooltip="publish-expose"
							i18n-matTooltip="@@expositions.list.publish"
							matTooltipPosition="left"
							(click)="publishExposition(cell.data)">
							<mat-icon [svgIcon]="ActionIcons.PublishExposition"></mat-icon>
						</button>
						<button
							id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
							mat-icon-button
							class="actions-column-template__menu-btn"
							(click)="rowMenuOpen($event, cell.rowIndex)"
							[matMenuTriggerFor]="
								cell.data['apiStatus'] === PublicationStatus.Unpublished
									? unpublishedActions
									: cell.data['apiStatus'] === PublicationStatus.Available
									? publishedActiveActions
									: publishedInActiveActions
							"
							[matMenuTriggerData]="{ $implicit: cell.data }">
							<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
						</button>
					</div>

					<mat-menu #publishedInActiveActions="matMenu">
						<ng-template matMenuContent let-data>
							<button
								*ngFor="let a of rowMenuPublishedInActiveActions"
								id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
								(click)="a.action(data)"
								mat-menu-item>
								<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
								<span>{{ a.description }}</span>
							</button>
						</ng-template>
					</mat-menu>

					<mat-menu #publishedActiveActions="matMenu">
						<ng-template matMenuContent let-data>
							<button
								*ngFor="let a of rowMenuPublishedActiveActions"
								id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
								(click)="a.action(data)"
								mat-menu-item>
								<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
								<span>{{ a.description }}</span>
							</button>
						</ng-template>
					</mat-menu>
					<mat-menu #unpublishedActions="matMenu">
						<ng-template matMenuContent let-data>
							<button
								*ngFor="let a of rowMenuNotPublishedActions"
								id="{{ cmpId }}-{{ cell.rowIndex }}-{{ a.actionName }}-btn"
								(click)="a.action(data)"
								mat-menu-item>
								<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
								<span>{{ a.description }}</span>
							</button>
						</ng-template>
					</mat-menu>
				</div>

				<dxo-group-panel [visible]="true"></dxo-group-panel>

				<!-- Sorting	-->
				<dxo-sorting mode="multiple"></dxo-sorting>

				<!-- Pagination -->
				<dxo-paging [pageSize]="50"></dxo-paging>

				<!-- Filterable columns	-->
				<dxo-header-filter [visible]="true"></dxo-header-filter>

				<dxo-filter-row
					[visible]="vo.list.elements.size !== 0"></dxo-filter-row>

				<dxo-column-chooser
					[allowSearch]="true"
					[enabled]="false"
					[mode]="'select'">
					<dxo-selection
						[allowSelectAll]="true"
						[recursive]="false"></dxo-selection>
				</dxo-column-chooser>

				<dxo-filter-panel [visible]="true"></dxo-filter-panel>
				<dxo-filter-builder [allowHierarchicalFields]="true">
					<!--					<dxi-field dataField="tagsArr">-->
					<!--						<dxo-lookup [dataSource]="tagsFilterLookup"></dxo-lookup>-->
					<!--					</dxi-field>-->
					<!--					<dxi-field dataField="apiStatus">-->
					<!--						<dxo-lookup [dataSource]="lookupData"></dxo-lookup>-->
					<!--					</dxi-field>-->
				</dxo-filter-builder>

				<dxo-state-storing
					type="custom"
					[enabled]="true"
					[savingTimeout]="160"
					[customLoad]="loadState"
					[customSave]="saveState"></dxo-state-storing>
			</dx-data-grid>
			<ng-container
				*ngIf="!vo.isLoading && vo.list.elements.size === 0"
				[ngTemplateOutlet]="noData"></ng-container>
		</app-panel>
	</ng-template>
	<ng-template #noData>
		<div class="no-data-template">
			<mat-icon [svgIcon]="DcIcons.ExposeDatablock"></mat-icon>
			<app-button
				*ngIf="vo.canCreate"
				class="small"
				id="{{ cmpId }}-add-new"
				[leftIcon]="DcIcons.AddCircle"
				i18n="@@expositions.list.action.new"
				(click)="
					vo.embedded
						? createNewExpositionFromEmbeddedView()
						: createNewExposition()
				">
				new-exposition
			</app-button>
		</div>
	</ng-template>
</ng-container>
